export default {
  'tree-pass': {
    width: 100,
    height: 100,
    d: 'M 47.5 0 H 52.5 V 100 H 47.5 L 47.5 0'
  },
  'tree-node': {
    width: 100,
    height: 100,
    d: 'M 47.5 0 H 52.5 V 47.5 H 100 V 52.5 H 52.5 V 100 H 47.5 L 47.5 0'
  },
  'tree-last': {
    width: 100,
    height: 100,
    d: 'M 47.5 0 H 52.5 V 47.5 H 100 V 52.5 H 47.5 L 47.5 0'
  },
  'tree-skip': {
    width: 100,
    height: 100,
    d: ''
  }
}